import { useState } from 'react';
import type { Product } from '../types';
import { conditionLabels, money } from '../utils/labels';

interface Props {
  product: Product;
  categoryName: string;
  onOpen: (product: Product) => void;
  onOrder: (product: Product) => void;
  onShare: (product: Product) => void;
}

export default function ProductCard({ product, categoryName, onOpen, onOrder, onShare }: Props) {
  const [selected, setSelected] = useState(0);
  const images = product.images.slice(0, 4);
  const thumbnails = images.map((image, index) => ({ image, index })).filter((item) => item.index !== selected);
  return (
    <article className="product-card">
      <button className="product-main-image" onClick={() => onOpen(product)} aria-label={`פתיחת ${product.title}`}>
        {images[selected] ? <img src={images[selected].url} alt={product.title} loading="lazy" /> : <div className="image-placeholder">אין תמונה</div>}
        <span className={`condition-badge ${product.status === 'reserved' ? 'reserved' : ''}`}>
          {product.status === 'reserved' ? 'המוצר שמור' : conditionLabels[product.condition]}
        </span>
      </button>
      {thumbnails.length > 0 && <div className="thumbnail-row">
        {thumbnails.map(({ image, index }) => (
          <button key={image.id} onClick={() => setSelected(index)} aria-label={`תמונה ${index + 1}`}>
            <img src={image.url} alt="" loading="lazy" />
          </button>
        ))}
      </div>}
      <button className="card-details" onClick={() => onOpen(product)}>
        <h2>{product.title}</h2>
        <p>{conditionLabels[product.condition]} · {categoryName}</p>
        <div className="price-row">
          <strong>{money(product.price_cents)}</strong>
          {product.old_price_cents !== null && <del>{money(product.old_price_cents)}</del>}
        </div>
      </button>
      <p className="compact-info">BIT · PayBox · מזומן<br />איסוף מראש העין או משלוח</p>
      <div className="card-actions">
        <button className="primary" disabled={product.status === 'reserved'} onClick={() => onOrder(product)}>
          {product.status === 'reserved' ? 'המוצר שמור' : 'שליחת הזמנה'}
        </button>
        <button className="icon-button" onClick={() => onShare(product)} aria-label="שיתוף מוצר">↗</button>
      </div>
    </article>
  );
}
